import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FlashService } from './flash.service';
@Injectable({
  providedIn: 'root'
})
export class DataService {

    constructor(private http: HttpClient, private flashService: FlashService) {
    }

    GetMetadata(metadata: any): Promise<any> {
        var self = this;
        return self.http.get('/api/MetaData/' + metadata).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    };

    GetData(id) {
        var self = this;
        if (id) {
            return self.http.get('/api/Data/' + id).toPromise().then(self.handleSuccess, self.handleError.bind(this));
        } else {
            return self.http.get('/api/Data').toPromise().then(self.handleSuccess, self.handleError.bind(this));
        }
    }

    Save(data) {
        var self = this;
        return self.http.post('/api/Data', data).toPromise().then(self.handleSuccess, self.handleError.bind(this));
    }

    Remove(ids) {
        var self = this;
        return self.http.request('DELETE', '/api/Data', {
            headers: new HttpHeaders({ "Content-Type": "application/json;charset=utf-8" }),
            body: { ids: ids }
        }).toPromise().then(self.handleSuccess, self.handleError.bind(this));
}
    private handleSuccess(res) {
        return res;
    }

    private handleError(res) {
       this.flashService.Error(res.error.errors.toString(), false);
       return { success: false };
    }
}
